/* Bom — Haru & Bom theme scripts (vanilla, no dependencies) */
(() => {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const T = window.theme || {};
  const store = {
    get(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  const debounce = (fn, ms = 300) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  function formatMoney(cents) {
    const fmt = T.moneyFormat || '{{amount_with_comma_separator}} €';
    const value = (cents / 100).toFixed(2);
    const [i, d] = value.split('.');
    const withSep = (sep, dec) => i.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + dec + d;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount': return withSep(',', '.');
        case 'amount_no_decimals': return i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        case 'amount_with_comma_separator': return withSep('.', ',');
        case 'amount_no_decimals_with_comma_separator': return i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        case 'amount_with_space_separator': return withSep(' ', ',');
        default: return withSep(' ', ',');
      }
    });
  }

  function toast(msg) {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.hidden = true; }, 2600);
  }

  /* ---------------- Overlay / drawers ---------------- */
  const overlay = $('[data-overlay]');
  let openDrawerEl = null;
  let lastFocus = null;

  function openDrawer(el) {
    if (!el) return;
    if (openDrawerEl && openDrawerEl !== el) closeDrawer(openDrawerEl, true);
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => {
      el.classList.add('is-open');
      if (overlay) { overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-visible')); }
    });
    document.body.classList.add('is-locked');
    openDrawerEl = el;
    const focusTarget = $('[data-autofocus]', el) || $('button, a, input', el);
    setTimeout(() => focusTarget && focusTarget.focus({ preventScroll: true }), 350);
    if (el.id === 'MenuDrawer') $$('.header-wrapper').forEach((h) => h.classList.add('menu-open'));
  }
  function closeDrawer(el = openDrawerEl, silent) {
    if (!el) return;
    el.classList.remove('is-open');
    if (!silent && overlay) { overlay.classList.remove('is-visible'); setTimeout(() => { overlay.hidden = true; }, 350); }
    document.body.classList.remove('is-locked');
    $$('.header-wrapper').forEach((h) => h.classList.remove('menu-open'));
    openDrawerEl = null;
    if (lastFocus && !silent) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const target = document.getElementById(opener.dataset.drawerOpen);
      if (target) { e.preventDefault(); openDrawer(target); if (target.id === 'SearchModal') initSearchFocus(); }
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) closeDrawer();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeLightbox(); closeModal(); } });

  /* ---------------- Header ---------------- */
  function initHeader() {
    const wrap = $('.header-wrapper');
    if (!wrap) return;
    const setVars = () => {
      const h = wrap.offsetHeight;
      document.documentElement.style.setProperty('--header-h', h + 'px');
      document.documentElement.style.setProperty('--sticky-top', wrap.classList.contains('is-sticky') ? h + 'px' : '0px');
    };
    setVars();
    window.addEventListener('resize', debounce(setVars, 150));
    let lastY = window.scrollY;
    const hideOnScroll = wrap.dataset.hideOnScroll === 'true';
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      wrap.classList.toggle('is-scrolled', y > 10);
      if (hideOnScroll && wrap.classList.contains('is-sticky')) {
        const hide = y > lastY && y > 300 && !openDrawerEl;
        wrap.classList.toggle('is-hidden', hide);
        document.documentElement.style.setProperty('--sticky-top', hide ? '0px' : wrap.offsetHeight + 'px');
      }
      lastY = y;
    }, { passive: true });
  }

  /* ---------------- Announcement ---------------- */
  function initAnnouncements(root = document) {
    $$('[data-announcement]', root).forEach((bar) => {
      const items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      let i = 0;
      const show = (n) => { items[i].classList.remove('is-active'); i = (n + items.length) % items.length; items[i].classList.add('is-active'); };
      let timer = setInterval(() => show(i + 1), (parseInt(bar.dataset.speed, 10) || 5) * 1000);
      $('[data-prev]', bar)?.addEventListener('click', () => { show(i - 1); clearInterval(timer); });
      $('[data-next]', bar)?.addEventListener('click', () => { show(i + 1); clearInterval(timer); });
    });
  }

  /* ---------------- Sliders ---------------- */
  function initSliders(root = document) {
    $$('[data-slider]', root).forEach((wrap) => {
      if (wrap._init) return; wrap._init = true;
      const track = $('.slider', wrap);
      if (!track) return;
      const prev = $('[data-slider-prev]', wrap);
      const next = $('[data-slider-next]', wrap);
      const dotsWrap = $('[data-slider-dots]', wrap);
      const step = () => { const item = track.children[0]; return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth; };
      prev?.addEventListener('click', () => track.scrollBy({ left: -step() * (window.innerWidth > 989 ? 2 : 1) }));
      next?.addEventListener('click', () => track.scrollBy({ left: step() * (window.innerWidth > 989 ? 2 : 1) }));
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 4;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max;
        if (dotsWrap) {
          const pages = Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth - 0.05));
          if (dotsWrap.children.length !== pages) {
            dotsWrap.innerHTML = '';
            if (pages > 1) for (let p = 0; p < pages; p++) { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Page ' + (p + 1)); b.addEventListener('click', () => track.scrollTo({ left: p * track.clientWidth })); dotsWrap.appendChild(b); }
          }
          const cur = Math.round(track.scrollLeft / track.clientWidth);
          $$('button', dotsWrap).forEach((b, n) => b.setAttribute('aria-current', n === cur));
        }
      };
      track.addEventListener('scroll', debounce(update, 60), { passive: true });
      window.addEventListener('resize', debounce(update, 200));
      update();
      if (wrap.dataset.autoplay) {
        const ms = parseInt(wrap.dataset.autoplay, 10) * 1000;
        let t = setInterval(() => {
          if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 4) track.scrollTo({ left: 0 });
          else track.scrollBy({ left: step() });
        }, ms);
        wrap.addEventListener('pointerenter', () => clearInterval(t));
      }
    });
  }

  /* ---------------- Hero slideshow ---------------- */
  function initHero(root = document) {
    $$('[data-hero]', root).forEach((hero) => {
      if (hero._init) return; hero._init = true;
      const slides = $$('.hero__slide', hero);
      const dots = $$('[data-hero-dot]', hero);
      if (slides.length < 2) return;
      let i = 0;
      const go = (n) => {
        slides[i].classList.remove('is-active'); dots[i]?.setAttribute('aria-current', 'false');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); dots[i]?.setAttribute('aria-current', 'true');
        hero.style.setProperty('--hero-fg', slides[i].dataset.fg || '#fff');
      };
      dots.forEach((d, n) => d.addEventListener('click', () => { go(n); restart(); }));
      $('[data-hero-prev]', hero)?.addEventListener('click', () => { go(i - 1); restart(); });
      $('[data-hero-next]', hero)?.addEventListener('click', () => { go(i + 1); restart(); });
      const speed = (parseInt(hero.dataset.speed, 10) || 6) * 1000;
      let timer = null;
      const start = () => { if (hero.dataset.autoplay === 'true') timer = setInterval(() => go(i + 1), speed); };
      const restart = () => { clearInterval(timer); start(); };
      hero.addEventListener('pointerenter', () => clearInterval(timer));
      hero.addEventListener('pointerleave', restart);
      let x0 = null;
      hero.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) { go(dx < 0 ? i + 1 : i - 1); restart(); } x0 = null; });
      start();
    });
  }

  /* ---------------- Tabs ---------------- */
  function initTabs(root = document) {
    $$('[data-tabs]', root).forEach((wrap) => {
      if (wrap._init) return; wrap._init = true;
      const tabs = $$('[role=tab]', wrap);
      tabs.forEach((tab) => tab.addEventListener('click', () => {
        tabs.forEach((t) => { t.setAttribute('aria-selected', t === tab); const p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = t !== tab; });
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) initSliders(panel);
      }));
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal(root = document) {
    if (!document.body.classList.contains('has-animations')) return;
    $$('.slider [data-reveal], .slider-wrap [data-reveal]', root).forEach((e) => e.classList.add('is-visible'));
    const els = $$('[data-reveal]:not(.is-visible)', root);
    if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((e) => io.observe(e));
  }

  /* ---------------- Quantity inputs ---------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    if (!input) return;
    const min = parseInt(input.min || '0', 10);
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    let v = parseInt(input.value || '1', 10) + (btn.dataset.qtyBtn === 'plus' ? 1 : -1);
    v = Math.min(max, Math.max(min, v));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Cart ---------------- */
  const cartSections = () => {
    const ids = ['cart-drawer', 'cart-count'];
    const main = $('[data-main-cart]');
    if (main) ids.push(main.dataset.sectionId);
    return ids;
  };

  function renderCartSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const doc = parseHTML(sections['cart-drawer']);
      const fresh = $('[data-cart-drawer-inner]', doc);
      const cur = $('[data-cart-drawer-inner]');
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; initSliders(cur); initDelivery(cur); initAlma(cur); }
    }
    if (sections['cart-count']) {
      const doc = parseHTML(sections['cart-count']);
      const fresh = $('[data-cart-count]', doc);
      if (fresh) $$('[data-cart-count]').forEach((el) => { el.textContent = fresh.textContent; el.dataset.count = fresh.dataset.count; });
    }
    const main = $('[data-main-cart]');
    if (main && sections[main.dataset.sectionId]) {
      const doc = parseHTML(sections[main.dataset.sectionId]);
      const fresh = $('[data-main-cart]', doc);
      if (fresh) main.innerHTML = fresh.innerHTML;
    }
  }

  async function refreshCart() {
    const res = await fetch(`${T.routes.root}?sections=${cartSections().join(',')}`);
    renderCartSections(await res.json());
  }

  async function addToCart(items, button) {
    button?.classList.add('is-loading');
    try {
      const res = await fetch(T.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: cartSections(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) { toast(data.description || data.message || T.strings.error); return false; }
      if (T.cartType === 'page' && !$('[data-main-cart]')) { window.location.href = T.routes.cart; return true; }
      renderCartSections(data.sections);
      const drawer = $('#CartDrawer');
      if (drawer && !$('[data-main-cart]')) openDrawer(drawer); else toast(T.strings.added);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return true;
    } catch (err) {
      toast(T.strings.error);
      return false;
    } finally {
      button?.classList.remove('is-loading');
    }
  }

  async function changeLine(key, quantity, lineEl) {
    lineEl?.classList.add('is-loading');
    try {
      const res = await fetch(T.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: cartSections(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) { toast(data.description || data.message || T.strings.error); lineEl?.classList.remove('is-loading'); return; }
      renderCartSections(data.sections);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (e) { toast(T.strings.error); lineEl?.classList.remove('is-loading'); }
  }


  /* ---------------- Gift auto-add (plusieurs paliers + échantillon) ---------------- */
  let giftBusy = false;
  function activeGifts() {
    const list = Array.isArray(T.gifts) ? T.gifts : [];
    return list.filter((g) => {
      if (!g || !g.variant || !g.threshold) return false;
      if (g.end) { const end = new Date(g.end + 'T23:59:59'); if (!isNaN(end) && Date.now() > end.getTime()) return false; }
      return true;
    });
  }
  function giftActive() { return activeGifts().length > 0; }
  async function syncGift() {
    const gifts = activeGifts();
    if (!gifts.length || giftBusy) return;
    giftBusy = true;
    try {
      const cart = await (await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json();
      const isGiftLine = (i) => i.properties && i.properties._cadeau;
      const base = cart.items.filter((i) => !isGiftLine(i)).reduce((s, i) => s + i.final_line_price, 0);
      const paidCount = cart.items.filter((i) => !isGiftLine(i)).reduce((s, i) => s + i.quantity, 0);
      const toAdd = []; const updates = {};
      gifts.forEach((g) => {
        const lines = cart.items.filter((i) => i.variant_id === g.variant && isGiftLine(i) && i.properties._cadeau === g.key);
        let declined = false; try { declined = sessionStorage.getItem('bom-gift-off-' + g.key) === '1'; } catch (e) {}
        const ok = paidCount > 0 && base >= g.threshold;
        if (ok && lines.length === 0 && !declined) toAdd.push({ id: g.variant, quantity: 1, properties: { _cadeau: g.key } });
        else if (!ok && lines.length) lines.forEach((l) => { updates[l.key] = 0; });
        else if (lines.length === 1 && lines[0].quantity > 1) updates[lines[0].key] = 1;
        else if (lines.length > 1) lines.slice(1).forEach((l) => { updates[l.key] = 0; });
      });
      let changed = false;
      if (Object.keys(updates).length) {
        const r = await fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
        changed = changed || r.ok;
      }
      if (toAdd.length) {
        const r = await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: toAdd }) });
        changed = changed || r.ok;
      }
      if (changed) await refreshCart();
    } catch (e) { /* silencieux */ }
    finally { giftBusy = false; }
  }
  document.addEventListener('cart:updated', () => syncGift());

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) };
    const props = {};
    for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
    if (Object.keys(props).length) item.properties = props;
    if (fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
    addToCart([item], form.querySelector('[type=submit]'));
  });

  document.addEventListener('click', (e) => {
    const quick = e.target.closest('[data-quick-add]');
    if (quick) { e.preventDefault(); addToCart([{ id: parseInt(quick.dataset.quickAdd, 10), quantity: 1 }], quick); return; }
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); if (remove.hasAttribute('data-gift-remove')) { try { sessionStorage.setItem('bom-gift-off-' + (remove.dataset.giftRemove || 'offert'), '1'); } catch (err) {} } changeLine(remove.dataset.cartRemove, 0, remove.closest('.cart-item')); }
    const noteToggle = e.target.closest('[data-note-toggle]');
    if (noteToggle) { e.preventDefault(); const n = $('[data-cart-note]'); if (n) n.hidden = !n.hidden; }
  });

  document.addEventListener('change', debounce((e) => {
    const input = e.target.closest('[data-cart-qty]');
    if (input) changeLine(input.dataset.cartQty, parseInt(input.value, 10), input.closest('.cart-item'));
    const note = e.target.closest('[data-cart-note] textarea');
    if (note) fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  }, 350));


  /* Theme editor: explain blocked actions */
  document.addEventListener('click', (e) => {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    const blocked = e.target.closest('[name=checkout], a[href*="/account"], a[href*="/checkout"]');
    if (blocked) { e.preventDefault(); toast(T.strings.editorBlocked); }
  }, true);

  /* ---------------- Search ---------------- */
  function initSearchFocus() { setTimeout(() => $('#SearchModal [type=search]')?.focus(), 300); }
  function initPredictiveSearch() {
    const modal = $('#SearchModal');
    if (!modal) return;
    const input = $('[type=search]', modal);
    const results = $('[data-predictive-results]', modal);
    const initial = $('[data-search-initial]', modal);
    if (!input || !results || modal.dataset.predictive !== 'true') return;
    let ctrl;
    const run = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; if (initial) initial.hidden = false; return; }
      ctrl?.abort(); ctrl = new AbortController();
      try {
        const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,article,query&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,vendor,tag`;
        const res = await fetch(url, { signal: ctrl.signal });
        const html = await res.text();
        const doc = parseHTML(html);
        const content = $('[data-predictive-content]', doc);
        results.innerHTML = content ? content.innerHTML : '';
        if (initial) initial.hidden = true;
      } catch (err) { /* aborted */ }
    }, 250);
    input.addEventListener('input', run);
  }

  /* ---------------- Collection filters ---------------- */
  function initFacets() {
    const root = $('[data-facets-root]');
    if (!root) return;
    const sectionId = root.dataset.sectionId;

    const buildURL = (form) => {
      const params = new URLSearchParams();
      const fd = new FormData(form);
      for (const [k, v] of fd.entries()) if (v !== '') params.append(k, v);
      return params.toString();
    };

    const render = async (query, push = true) => {
      const grid = $('[data-product-grid]');
      grid?.classList.add('is-loading');
      const url = `${window.location.pathname}?${query}`;
      const res = await fetch(`${url}${query ? '&' : ''}section_id=${sectionId}`);
      const doc = parseHTML(await res.text());
      ['[data-product-grid]', '[data-facets-sidebar]', '[data-facets-drawer]', '[data-active-filters]', '[data-toolbar-count]', '[data-pagination]', '[data-filter-count]'].forEach((sel) => {
        const fresh = $(sel, doc);
        $$(sel).forEach((cur) => { if (fresh) cur.innerHTML = fresh.innerHTML; });
      });
      grid?.classList.remove('is-loading');
      if (push) history.replaceState({}, '', url);
      initReveal(); bindForms();
    };

    const onChange = debounce((form) => {
      const q = buildURL(form);
      // Sync the other forms (sidebar / drawer / sort)
      render(q);
    }, 400);

    function bindForms() {
      $$('form[data-facets-form]').forEach((form) => {
        if (form._bound) return; form._bound = true;
        form.addEventListener('change', () => onChange(mergeForms(form)));
        form.addEventListener('submit', (e) => { e.preventDefault(); onChange(mergeForms(form)); });
      });
    }
    // Merge sort select into the active facet form
    function mergeForms(form) {
      const temp = document.createElement('form');
      const add = (k, v) => { const i = document.createElement('input'); i.name = k; i.value = v; temp.appendChild(i); };
      const sort = $('[data-sort-select]');
      let source = form;
      if (form.hasAttribute('data-sort-only')) {
        const visible = $$('form[data-facets-form]:not([data-sort-only])').find((f) => f.offsetParent !== null);
        source = visible || $('form[data-facets-form]:not([data-sort-only])');
      }
      if (source) for (const [k, v] of new FormData(source).entries()) { if (k === 'sort_by' && sort) continue; add(k, v); }
      if (sort) add('sort_by', sort.value);
      return temp;
    }
    bindForms();

    document.addEventListener('click', (e) => {
      const a = e.target.closest('[data-facet-remove], [data-pagination] a');
      if (!a || !root.contains(a) && !a.closest('[data-facets-root]')) return;
      if (a.closest('[data-pagination]') && root.dataset.paginationType !== 'ajax') return;
      e.preventDefault();
      const u = new URL(a.href, window.location.origin);
      render(u.searchParams.toString()).then(() => { if (a.closest('[data-pagination]')) window.scrollTo({ top: root.offsetTop - 80, behavior: 'smooth' }); });
    });

    // Grid column toggle
    $$('[data-grid-cols]').forEach((b) => b.addEventListener('click', () => {
      const grid = $('[data-product-grid]');
      if (!grid) return;
      grid.style.setProperty('--grid-cols', b.dataset.gridCols);
      $$('[data-grid-cols]').forEach((x) => x.setAttribute('aria-pressed', x === b));
      store.set('bom-grid', b.dataset.gridCols);
    }));
    const saved = store.get('bom-grid');
    if (saved) $(`[data-grid-cols="${saved}"]`)?.click();
  }

  /* Facet 'voir plus' */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-facet-more]');
    if (!b) return;
    const g = b.closest('.facets__group');
    if (!b.dataset.more) b.dataset.more = b.textContent;
    g.classList.toggle('is-expanded');
    b.textContent = g.classList.contains('is-expanded') ? b.dataset.less : b.dataset.more;
  });

  /* Load more */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    const res = await fetch(btn.dataset.loadMore);
    const doc = parseHTML(await res.text());
    const grid = $('[data-product-grid]');
    const freshGrid = $('[data-product-grid]', doc);
    if (grid && freshGrid) Array.from(freshGrid.children).forEach((c) => grid.appendChild(c));
    const pag = $('[data-pagination]');
    const freshPag = $('[data-pagination]', doc);
    if (pag) pag.innerHTML = freshPag ? freshPag.innerHTML : '';
    initReveal();
  });

  /* ---------------- Product page ---------------- */
  function initProduct(root = document) {
    $$('[data-product]', root).forEach((wrap) => {
      if (wrap._init) return; wrap._init = true;
      const sectionId = wrap.dataset.sectionId;
      const url = wrap.dataset.url;
      const variantsEl = $('[data-variants-json]', wrap);
      const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      const form = $('form[data-product-form]', wrap);
      const idInput = form ? $('[name=id]', form) : null;

      const picker = $('[data-variant-picker]', wrap);
      picker?.addEventListener('change', async () => {
        const selected = $$('fieldset', picker).map((fs) => { const c = $('input:checked', fs) || $('select', fs); return c ? c.value : null; });
        $$('fieldset', picker).forEach((fs, n) => { const lab = $('[data-selected-value]', fs); if (lab) lab.textContent = selected[n]; });
        const variant = variants.find((v) => v.options.every((o, n) => o === selected[n]));
        if (!variant) { setButton(false, T.strings.unavailable); return; }
        if (idInput) idInput.value = variant.id;
        $$('[data-sticky-variant]').forEach((i) => { i.value = variant.id; });
        history.replaceState({}, '', `${url}?variant=${variant.id}`);
        if (variant.featured_media) goToMedia(wrap, variant.featured_media.id);
        const res = await fetch(`${url}?variant=${variant.id}&section_id=${sectionId}`);
        const doc = parseHTML(await res.text());
        ['[data-price]', '[data-stock]', '[data-buy-buttons-state]', '[data-sticky-price]', '[data-notify]'].forEach((sel) => {
          const fresh = $(sel, doc);
          $$(sel).forEach((cur) => { if (fresh) cur.innerHTML = fresh.innerHTML; });
        });
        setButton(variant.available, variant.available ? T.strings.addToCart : T.strings.soldOut);
        $$('[data-alma-slot]', wrap).forEach((sl) => { sl.dataset.almaAmount = variant.price; });
        initAlma(wrap);
      });

      function setButton(ok, label) {
        $$('[data-add-button]').forEach((b) => { b.disabled = !ok; const l = $('[data-add-label]', b); if (l) l.textContent = label; });
      }

      initGallery(wrap);
      initStickyATC(wrap);
      trackRecentlyViewed(wrap.dataset.handle);
    });
  }

  function goToMedia(wrap, mediaId) {
    const slide = $(`[data-media-id="${mediaId}"]`, wrap);
    const slider = $('.gallery__slider', wrap);
    if (slide && slider) slider.scrollTo({ left: slide.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
  }

  function initGallery(wrap) {
    const slider = $('.gallery__slider', wrap);
    if (!slider) return;
    const slides = $$('.gallery__slide', slider);
    const thumbs = $$('.gallery__thumb', wrap);
    const counter = $('[data-gallery-counter]', wrap);
    thumbs.forEach((t, n) => t.addEventListener('click', () => {
      if (getComputedStyle(slider).display === 'grid') { slides[n].scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      slider.scrollTo({ left: slides[n].offsetLeft - slider.offsetLeft, behavior: 'smooth' });
    }));
    slider.addEventListener('scroll', debounce(() => {
      const n = Math.round(slider.scrollLeft / slider.clientWidth);
      thumbs.forEach((t, i) => t.setAttribute('aria-current', i === n));
      if (counter) counter.textContent = `${n + 1} / ${slides.length}`;
      thumbs[n]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }, 60), { passive: true });
    slides.forEach((s, n) => s.addEventListener('click', () => { if (s.dataset.mediaType === 'image') openLightbox(slides.filter((x) => x.dataset.mediaType === 'image'), s); }));
  }

  /* Lightbox */
  let lb = null; let lbList = []; let lbIdx = 0;
  function openLightbox(list, current) {
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'lightbox';
      lb.innerHTML = '<button class="lightbox__close" aria-label="Fermer"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6 6 18"/></svg></button><button class="lightbox__nav lightbox__nav--prev" aria-label="Précédent"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m15 6-6 6 6 6"/></svg></button><img alt=""><button class="lightbox__nav lightbox__nav--next" aria-label="Suivant"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m9 6 6 6-6 6"/></svg></button>';
      document.body.appendChild(lb);
      $('.lightbox__close', lb).addEventListener('click', closeLightbox);
      $('.lightbox__nav--prev', lb).addEventListener('click', () => showLb(lbIdx - 1));
      $('.lightbox__nav--next', lb).addEventListener('click', () => showLb(lbIdx + 1));
      lb.addEventListener('click', (e) => { if (e.target === lb) closeLightbox(); });
    }
    lbList = list; showLb(list.indexOf(current));
    lb.classList.add('is-open'); document.body.classList.add('is-locked');
  }
  function showLb(n) {
    lbIdx = (n + lbList.length) % lbList.length;
    const src = lbList[lbIdx].dataset.zoom;
    $('img', lb).src = src;
    $$('.lightbox__nav', lb).forEach((b) => { b.hidden = lbList.length < 2; });
  }
  function closeLightbox() { if (lb && lb.classList.contains('is-open')) { lb.classList.remove('is-open'); document.body.classList.remove('is-locked'); } }

  function initStickyATC(wrap) {
    const bar = $('[data-sticky-atc]');
    const main = $('[data-add-button]', wrap);
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    const footer = $('footer');
    let mainVisible = true; let footerVisible = false;
    const sync = () => bar.classList.toggle('is-visible', !mainVisible && !footerVisible && main.getBoundingClientRect().top < 0);
    new IntersectionObserver(([en]) => { mainVisible = en.isIntersecting; sync(); }).observe(main);
    if (footer) new IntersectionObserver(([en]) => { footerVisible = en.isIntersecting; sync(); }).observe(footer);
  }

  /* ---------------- Recently viewed ---------------- */
  function trackRecentlyViewed(handle) {
    if (!handle) return;
    const list = (store.get('bom-recent') || []).filter((h) => h !== handle);
    list.unshift(handle);
    store.set('bom-recent', list.slice(0, 12));
  }
  async function initRecentlyViewed() {
    const wrap = $('[data-recently-viewed]');
    if (!wrap) return;
    const current = wrap.dataset.current;
    const max = parseInt(wrap.dataset.limit || '8', 10);
    const handles = (store.get('bom-recent') || []).filter((h) => h !== current).slice(0, max);
    if (!handles.length) { wrap.closest('.section-recently')?.setAttribute('hidden', ''); return; }
    const track = $('.slider', wrap);
    const cards = await Promise.all(handles.map((h) => fetch(`${T.routes.root.replace(/\/$/, '')}/products/${h}?view=card`).then((r) => (r.ok ? r.text() : '')).catch(() => '')));
    track.innerHTML = cards.filter(Boolean).map((c) => `<div>${c}</div>`).join('');
    if (!track.children.length) wrap.closest('.section-recently')?.setAttribute('hidden', '');
    else { wrap.closest('.section-recently')?.removeAttribute('hidden'); wrap._init = false; initSliders(wrap.parentElement); wishPaint(wrap); }
  }

  /* ---------------- Countdown ---------------- */
  function initCountdowns(root = document) {
    $$('[data-countdown]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) return;
      const hideWhenDone = el.dataset.hideExpired === 'true';
      const section = el.closest('.shopify-section');
      const units = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
      const tick = () => {
        let diff = Math.max(0, end - Date.now());
        if (diff === 0) { clearInterval(t); if (hideWhenDone && section) section.hidden = true; }
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        if (units.d) units.d.textContent = String(d).padStart(2, '0');
        if (units.h) units.h.textContent = String(h).padStart(2, '0');
        if (units.m) units.m.textContent = String(m).padStart(2, '0');
        if (units.s) units.s.textContent = String(s).padStart(2, '0');
      };
      const t = setInterval(tick, 1000); tick();
    });
  }

  /* ---------------- Videos (UGC) ---------------- */
  function initVideos(root = document) {
    const vids = $$('.ugc-card video', root);
    if (!vids.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { const v = en.target; if (en.isIntersecting) v.play().catch(() => {}); else v.pause(); }), { threshold: 0.4 });
    vids.forEach((v) => io.observe(v));
  }

  /* ---------------- Modal / popup ---------------- */
  let openModalEl = null;
  function openModal(el) { if (!el) return; el.hidden = false; requestAnimationFrame(() => el.classList.add('is-open')); openModalEl = el; document.body.classList.add('is-locked'); }
  function closeModal() { if (!openModalEl) return; openModalEl.classList.remove('is-open'); document.body.classList.remove('is-locked'); const el = openModalEl; setTimeout(() => { el.hidden = true; }, 300); if (el.id === 'NewsletterPopup') store.set('bom-popup', Date.now()); openModalEl = null; }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-modal-close]') || e.target.classList.contains('modal')) closeModal();
    const op = e.target.closest('[data-modal-open]');
    if (op) { e.preventDefault(); openModal(document.getElementById(op.dataset.modalOpen)); }
  });
  function initPopup() {
    const p = $('#NewsletterPopup');
    if (!p || !T.popup || !T.popup.enabled) return;
    if (window.Shopify && window.Shopify.designMode) return;
    const last = store.get('bom-popup');
    if (last && Date.now() - last < T.popup.days * 864e5) return;
    if (p.dataset.posted === 'true') { openModal(p); return; }
    setTimeout(() => { if (!openDrawerEl) openModal(p); }, T.popup.delay * 1000);
  }

  /* ---------------- Misc ---------------- */
  function initMisc(root = document) {
    // Collection description read more
    $$('[data-clamp]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const btn = el.nextElementSibling;
      if (el.scrollHeight <= el.clientHeight + 4) { if (btn) btn.hidden = true; return; }
      btn?.addEventListener('click', () => { el.classList.toggle('is-clamped'); btn.textContent = el.classList.contains('is-clamped') ? btn.dataset.more : btn.dataset.less; });
    });
    // Footer collapsible
    $$('.footer__col--collapsible .footer__heading', root).forEach((h) => { if (h._init) return; h._init = true; h.addEventListener('click', () => h.parentElement.classList.toggle('is-open')); });
    // Share
    $$('[data-share]', root).forEach((b) => { if (b._init) return; b._init = true; b.addEventListener('click', async () => {
      const data = { title: document.title, url: b.dataset.share };
      if (navigator.share) { try { await navigator.share(data); } catch (e) {} } else { try { await navigator.clipboard.writeText(data.url); toast(T.strings.linkCopied); } catch (e) {} }
    }); });
  }


  /* ---------------- Delivery estimate ---------------- */
  function initDelivery(root = document) {
    const fmt = (d) => d.toLocaleDateString(T.locale === 'en' ? 'en-GB' : 'fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }).replace('.', '');
    const add = (days, weekend) => {
      const d = new Date(); let n = days;
      if (!weekend) { while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1); }
      while (n > 0) { d.setDate(d.getDate() + 1); if (weekend || (d.getDay() !== 0 && d.getDay() !== 6)) n--; }
      return d;
    };
    $$('[data-delivery]', root).forEach((el) => {
      let steps; try { steps = JSON.parse(el.dataset.delivery); } catch (e) { return; }
      steps.forEach((st, i) => {
        const out = $(`[data-delivery-date="${i}"]`, el); if (!out) return;
        const a = add(st.min, st.weekend); const b = add(st.max, st.weekend);
        out.textContent = st.min === st.max ? fmt(a) : `${fmt(a)} – ${fmt(b)}`;
      });
    });
  }

  /* ---------------- Alma (optional native widget) ---------------- */
  let almaWidgets = null;
  function initAlma(root = document) {
    const slots = $$('[data-alma-slot]', root);
    const mid = T.almaMerchantId;
    if (!slots.length || !mid) return;
    const run = () => {
      if (!window.Alma) return;
      if (!almaWidgets) almaWidgets = Alma.Widgets.initialize(mid, Alma.ApiMode.LIVE);
      slots.forEach((slot) => {
        slot.innerHTML = '';
        almaWidgets.add(Alma.Widgets.PaymentPlans, { container: '#' + slot.id, purchaseAmount: parseInt(slot.dataset.almaAmount || '0', 10), locale: 'fr' });
      });
    };
    if (window.Alma) return run();
    if (!document.getElementById('alma-widgets-js')) {
      const css = document.createElement('link'); css.rel = 'stylesheet'; css.href = 'https://cdn.jsdelivr.net/npm/@alma/widgets@4.x/dist/widgets.min.css'; document.head.appendChild(css);
      const js = document.createElement('script'); js.id = 'alma-widgets-js'; js.src = 'https://cdn.jsdelivr.net/npm/@alma/widgets@4.x/dist/widgets.umd.js'; js.onload = run; document.head.appendChild(js);
    }
  }

  /* ---------------- Discount codes ---------------- */
  async function setDiscounts(codes, box) {
    box?.classList.add('is-loading');
    try {
      const res = await fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: codes.join(','), sections: cartSections(), sections_url: window.location.pathname }) });
      const data = await res.json();
      if (!res.ok) { toast(data.description || T.strings.error); return; }
      renderCartSections(data.sections);
      const added = (data.discount_codes || []).find((d) => codes.length && d.code.toLowerCase() === codes[codes.length - 1].toLowerCase());
      if (added && !added.applicable) toast(T.strings.codeNotApplicable);
      else if (codes.length) toast(T.strings.codeApplied);
      initDelivery(); initAlma();
    } catch (e) { toast(T.strings.error); } finally { box?.classList.remove('is-loading'); }
  }
  const currentCodes = (box) => $$('[data-code]', box || document).map((c) => c.dataset.code);
  document.addEventListener('click', (e) => {
    const apply = e.target.closest('[data-discount-apply]');
    if (apply) {
      const box = apply.closest('[data-cart-discount]'); const input = $('[data-discount-input]', box);
      const code = (input.value || '').trim(); if (!code) return;
      setDiscounts([...currentCodes(box).filter((c) => c.toLowerCase() !== code.toLowerCase()), code], box);
    }
    const rm = e.target.closest('[data-discount-remove]');
    if (rm) { const box = rm.closest('[data-cart-discount]'); setDiscounts(currentCodes(box).filter((c) => c !== rm.dataset.discountRemove), box); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches('[data-discount-input]')) { e.preventDefault(); e.target.closest('[data-cart-discount]').querySelector('[data-discount-apply]').click(); }
  });

  /* ---------------- Localization auto-submit ---------------- */
  document.addEventListener('change', (e) => { const sel = e.target.closest('[data-auto-submit]'); if (sel) sel.form.submit(); });

  /* ---------------- Header search bar opens instant search ---------------- */
  document.addEventListener('focusin', (e) => {
    const bar = e.target.closest('[data-search-bar] input');
    if (!bar || !T.predictive) return;
    const modal = $('#SearchModal'); if (!modal) return;
    if (modal.classList.contains('is-open')) return;
    openDrawer(modal);
    lastFocus = null;
    const inp = $('[type=search]', modal);
    setTimeout(() => { inp.value = bar.value; inp.focus(); inp.dispatchEvent(new Event('input')); }, 80);
    bar.blur();
  });


  /* ---------------- Wishlist (favoris) ---------------- */
  const WKEY = 'bom-wishlist';
  const wishGet = () => { const v = store.get(WKEY); return Array.isArray(v) ? v : []; };
  function wishPaint(root = document) {
    const list = wishGet();
    $$('[data-wishlist]', root).forEach((b) => {
      const on = list.includes(b.dataset.wishlist);
      b.setAttribute('aria-pressed', on);
      b.classList.toggle('is-active', on);
    });
    $$('[data-wishlist-count]').forEach((c) => { c.textContent = list.length || ''; c.dataset.count = list.length; });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wishlist]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    let list = wishGet();
    const h = b.dataset.wishlist;
    const on = !list.includes(h);
    list = on ? [h, ...list] : list.filter((x) => x !== h);
    store.set(WKEY, list.slice(0, 60));
    wishPaint();
    toast(on ? T.strings.wishAdded : T.strings.wishRemoved);
    if (!on) { const card = b.closest('[data-wishlist-grid] > *'); if (card) { card.remove(); wishEmpty(); } }
  });
  function wishEmpty() {
    const grid = $('[data-wishlist-grid]'); const empty = $('[data-wishlist-empty]');
    if (grid && empty) empty.hidden = grid.children.length > 0;
  }
  async function initWishlistPage() {
    const grid = $('[data-wishlist-grid]');
    if (!grid || grid._init) return; grid._init = true;
    const list = wishGet();
    const htmls = await Promise.all(list.map((h) => fetch(`${T.routes.root.replace(/\/$/, '')}/products/${encodeURIComponent(h)}?view=card`).then((r) => (r.ok ? r.text() : '')).catch(() => '')));
    grid.innerHTML = '';
    htmls.forEach((html) => { if (!html.trim()) return; const d = document.createElement('div'); d.innerHTML = html; if (d.firstElementChild) grid.appendChild(d.firstElementChild); });
    wishEmpty(); wishPaint(grid);
  }

  /* ---------------- Bundles ---------------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-bundle-add]');
    if (!b) return;
    e.preventDefault();
    const ids = (b.dataset.variants || '').split(',').filter(Boolean).map((x) => parseInt(x, 10));
    if (!ids.length) return;
    const name = b.dataset.bundleName || 'Bundle';
    const ok = await addToCart(ids.map((id) => ({ id, quantity: 1, properties: { Bundle: name } })), b);
    const code = (b.dataset.code || '').trim();
    if (ok && code) {
      try {
        const cart = await (await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json();
        const codes = (cart.discount_codes || []).map((d) => d.code).filter((c) => c.toLowerCase() !== code.toLowerCase());
        await setDiscounts([...codes, code]);
      } catch (err) {}
    }
  });

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-add-many]');
    if (!b) return;
    e.preventDefault();
    const ids = b.dataset.addMany.split(',').filter(Boolean).map((x) => ({ id: parseInt(x, 10), quantity: 1 }));
    if (ids.length) addToCart(ids, b);
  });

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-tag-more]');
    if (!b) return;
    const box = b.closest('[data-tag-box]');
    const extra = $$('[data-tag-extra]', box);
    const open = b.dataset.open === '1';
    extra.forEach((x) => { x.hidden = open; });
    if (!b.dataset.more) b.dataset.more = b.textContent;
    b.textContent = open ? b.dataset.more : b.dataset.less;
    b.dataset.open = open ? '0' : '1';
  });

  document.addEventListener('input', (e) => {
    const inp = e.target.closest('[data-brand-search]');
    if (!inp) return;
    const q = inp.value.trim().toLowerCase();
    let total = 0;
    $$('[data-brand-group]').forEach((g) => {
      let n = 0;
      $$('[data-brand-name]', g).forEach((it) => { const ok = !q || it.dataset.brandName.includes(q); it.hidden = !ok; if (ok) n++; });
      g.hidden = n === 0; total += n;
    });
    const empty = $('[data-brand-empty]'); if (empty) empty.hidden = total > 0;
  });

  /* ---------------- Skin diagnostic ---------------- */
  function initQuiz(root = document) {
    $$('[data-quiz]', root).forEach((q) => {
      if (q._init) return; q._init = true;
      const intro = $('[data-quiz-intro]', q), stepsWrap = $('[data-quiz-steps]', q), resWrap = $('[data-quiz-results]', q);
      const steps = $$('[data-quiz-step]', q);
      const KEY = 'bom-skin';
      let cur = 0; let answers = [];
      const order = ['sensible', 'mixte', 'grasse', 'seche'];
      const show = (n) => {
        steps.forEach((s, i) => { s.hidden = i !== n; });
        cur = n;
        $('[data-quiz-current]', q).textContent = n + 1;
        $('[data-quiz-progress]', q).style.width = ((n) / steps.length * 100) + '%';
        $('[data-quiz-back]', q).hidden = n === 0;
      };
      const showResult = (res) => {
        intro.hidden = true; stepsWrap.hidden = true; resWrap.hidden = false;
        $$('[data-quiz-result]', q).forEach((r) => { r.hidden = r.dataset.quizResult !== res.type; });
        $$('[data-quiz-concern-result]', q).forEach((r) => { r.hidden = r.dataset.quizConcernResult !== res.concern; });
        const tags = $('[data-quiz-tags]', q);
        if (tags) tags.value = 'newsletter,diagnostic-peau,peau-' + res.type;
        q.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      const finish = () => {
        const count = {};
        answers.forEach((a) => { if (a.type) count[a.type] = (count[a.type] || 0) + 1; });
        let best = null;
        order.forEach((t) => { if (count[t] && (!best || count[t] > count[best])) best = t; });
        const concernA = answers.find((a) => a.concern);
        const resEl = $(`[data-quiz-result="${best}"]`, q);
        const res = { type: best || 'mixte', concern: concernA ? concernA.concern : null, label: resEl ? resEl.dataset.resultLabel : '', date: Date.now() };
        store.set(KEY, res);
        showResult(res);
      };
      $('[data-quiz-start]', q)?.addEventListener('click', () => { answers = []; intro.hidden = true; resWrap.hidden = true; stepsWrap.hidden = false; show(0); });
      $('[data-quiz-back]', q)?.addEventListener('click', () => { if (cur > 0) { answers.pop(); show(cur - 1); } });
      $('[data-quiz-restart]', q)?.addEventListener('click', () => { answers = []; resWrap.hidden = true; stepsWrap.hidden = false; show(0); q.scrollIntoView({ behavior: 'smooth' }); });
      $$('.quiz__answer', q).forEach((btn) => btn.addEventListener('click', () => {
        answers[cur] = { type: btn.dataset.quizType || null, concern: btn.dataset.quizConcern || null };
        answers.length = cur + 1;
        if (cur + 1 < steps.length) show(cur + 1); else finish();
      }));
      const last = store.get(KEY);
      if (last && last.type) {
        const box = $('[data-quiz-last]', q);
        if (box) { box.hidden = false; $('[data-quiz-last-label]', box).textContent = last.label || last.type; }
        $('[data-quiz-show-last]', q)?.addEventListener('click', () => showResult(last));
        if (window.location.search.includes('customer_posted=true') || window.location.hash.indexOf('QuizEmail') > -1) showResult(last);
      }
    });
  }

  function initAll(root = document) {
    initSliders(root); initHero(root); initTabs(root); initReveal(root); initCountdowns(root); initVideos(root); initMisc(root); initAnnouncements(root); initProduct(root); initDelivery(root); initAlma(root); initQuiz(root); wishPaint(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeader(); initAll(); initPredictiveSearch(); initFacets(); initRecentlyViewed(); initPopup(); initWishlistPage(); if (giftActive()) syncGift();
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => { initAll(e.target); if (e.target.querySelector('[data-facets-root]')) initFacets(); if (e.target.querySelector('.header-wrapper')) initHeader(); });
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('.hero__slide');
    if (slide) { const hero = slide.closest('[data-hero]'); const slides = $$('.hero__slide', hero); slides.forEach((s) => s.classList.toggle('is-active', s === slide)); }
    const item = e.target.closest('.slider > *');
    if (item) item.parentElement.scrollTo({ left: item.offsetLeft - item.parentElement.offsetLeft, behavior: 'smooth' });
    const annItem = e.target.closest('.announcement__item');
    if (annItem) $$('.announcement__item', annItem.parentElement).forEach((a) => a.classList.toggle('is-active', a === annItem));
  });
  document.addEventListener('shopify:section:select', (e) => { if (e.target.querySelector('#NewsletterPopup')) openModal($('#NewsletterPopup')); });

  /* ---------------- Estimation livraison (panier) ---------------- */
  (function () {
    const root = document.documentElement;
    let saved = null;
    try { saved = localStorage.getItem('hb-ship-dest'); } catch (e) {}
    const def = (document.querySelector('[data-ship-est]') || {}).dataset?.default || (T.country === 'FR' ? 'FR' : 'RE');
    root.setAttribute('data-ship-dest', saved || def);
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-ship-set]');
      if (!b) return;
      e.preventDefault();
      root.setAttribute('data-ship-dest', b.dataset.shipSet);
      try { localStorage.setItem('hb-ship-dest', b.dataset.shipSet); } catch (e2) {}
    });
  })();

  /* ---------------- Marque de la semaine : masquer à l'expiration ---------------- */
  (function () {
    const hideExpired = () => {
      const now = Date.now() / 1000;
      document.querySelectorAll('[data-bw-end]').forEach((el) => {
        if (parseInt(el.dataset.bwEnd, 10) <= now) {
          const holder = el.closest('.announcement__item--bw, .bw-section, .bw-article-mid, .bw-article-end') || el;
          holder.hidden = true; holder.style.display = 'none';
        }
      });
    };
    hideExpired(); setInterval(hideExpired, 60000);
  })();

  /* V13 — Fiche produit sur ordi : les onglets déroulants consécutifs deviennent une barre d'onglets compacte.
     Sur mobile (< 990px) on garde les onglets déroulants. Mêmes blocs, mêmes textes. */
  (function () {
    var mq = window.matchMedia('(min-width: 990px)');
    var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var T_MORE = en ? 'Read more' : 'Lire la suite', T_LESS = en ? 'Show less' : 'Réduire';
    function build(root) {
      (root || document).querySelectorAll('.product-info').forEach(function (info) {
        if (info.dataset.ptabs) return;
        var groups = [], cur = [];
        Array.prototype.forEach.call(info.children, function (el) {
          if (el.matches('details.accordion') && el.querySelector(':scope > .accordion__content')) { cur.push(el); }
          else { if (cur.length > 1) groups.push(cur); cur = []; }
        });
        if (cur.length > 1) groups.push(cur);
        if (!groups.length) return;
        info.dataset.ptabs = '1';
        groups.forEach(function (items) {
          var box = document.createElement('div'); box.className = 'ptabs';
          var nav = document.createElement('div'); nav.className = 'ptabs__nav'; nav.setAttribute('role', 'tablist');
          var panel = document.createElement('div'); panel.className = 'ptabs__panel'; panel.setAttribute('role', 'tabpanel');
          var inner = document.createElement('div'); inner.className = 'ptabs__inner';
          var more = document.createElement('button'); more.type = 'button'; more.className = 'ptabs__more'; more.textContent = T_MORE;
          panel.appendChild(inner); panel.appendChild(more);
          var contents = items.map(function (d) { return d.querySelector(':scope > .accordion__content'); });
          var btns = items.map(function (d, i) {
            var b = document.createElement('button'); b.type = 'button'; b.className = 'ptabs__tab'; b.setAttribute('role', 'tab');
            var t = d.querySelector('.accordion__title'); b.innerHTML = t ? t.innerHTML : d.querySelector('summary').textContent;
            b.addEventListener('click', function () { show(i); });
            nav.appendChild(b); return b;
          });
          box.appendChild(nav); box.appendChild(panel);
          // Sur ordi : bloc en pleine largeur sous la photo + la colonne d'achat (équilibre le scroll)
          box.classList.add('ptabs--wide');
          var grid = info.parentElement; grid.parentNode.insertBefore(box, grid.nextSibling);
          var active = -1, start = 0;
          items.forEach(function (d, i) { if (d.hasAttribute('open') && start === 0) start = i; });
          function giveBack() { if (active > -1) items[active].appendChild(contents[active]); }
          function measure() {
            panel.classList.remove('is-open'); more.textContent = T_MORE;
            more.hidden = inner.scrollHeight <= 380;
            panel.classList.toggle('is-clamped', !more.hidden);
          }
          function show(i) {
            giveBack(); active = i; inner.appendChild(contents[i]);
            btns.forEach(function (b, j) { b.classList.toggle('is-active', j === i); b.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
            measure();
          }
          more.addEventListener('click', function () {
            var open = panel.classList.toggle('is-open');
            panel.classList.toggle('is-clamped', !open);
            more.textContent = open ? T_LESS : T_MORE;
          });
          function apply() {
            if (mq.matches) { items.forEach(function (d) { d.classList.add('is-tabbed'); }); box.hidden = false; show(active > -1 ? active : start); }
            else { giveBack(); active = -1; items.forEach(function (d) { d.classList.remove('is-tabbed'); }); box.hidden = true; }
          }
          if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
          apply();
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { build(); }); else build();
    document.addEventListener('shopify:section:load', function (e) { build(e.target); });
  })();

  /* V13 — Fiche produit sur ordi : « Lire notre guide associé » + « Complète ta routine » passent sous les photos (colonne de gauche). */
  (function () {
    var mq = window.matchMedia('(min-width: 990px)');
    function build(root) {
      (root || document).querySelectorAll('.product > .product-info').forEach(function (info) {
        if (info.dataset.pside) return;
        var grid = info.parentElement;
        var items = Array.prototype.filter.call(info.children, function (el) { return el.matches('.guide-card, .complementary'); });
        if (!items.length) return;
        info.dataset.pside = '1';
        var side = document.createElement('div'); side.className = 'pside';
        var marks = items.map(function (el) { var m = document.createComment('pside'); el.parentNode.insertBefore(m, el); return m; });
        function apply() {
          if (mq.matches) { items.forEach(function (el) { side.appendChild(el); }); if (!side.parentNode) grid.appendChild(side); grid.classList.add('has-pside'); }
          else { items.forEach(function (el, i) { marks[i].parentNode.insertBefore(el, marks[i].nextSibling); }); if (side.parentNode) side.parentNode.removeChild(side); grid.classList.remove('has-pside'); }
        }
        if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
        apply();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { build(); }); else build();
    document.addEventListener('shopify:section:load', function (e) { build(e.target); });
  })();

  window.BomTheme = { openDrawer, closeDrawer, addToCart, refreshCart, formatMoney, toast };
})();
